module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG6601aaad353b673a6472c6e13fc87496.6601aaad.png";